// extracted by mini-css-extract-plugin
export default {"wrapper":"EnergyOEEConfig_wrapper__8fDfB","button":"EnergyOEEConfig_button__EuW9V"};